import moment from 'moment';

export const MORE_TICKERS = {
  'Oil Futures': [
    { name: 'Crude Oil', symbol: 'Crude%20Oil%20-%20Electronic' },
    { name: 'Brent Crude', symbol: 'UK:Brent%20Crude' }
  ],
  Currencies: [
    { name: 'USD/EUR', symbol: 'USDEUR' },
    { name: 'USDJPY', symbol: 'USDJPY' },
    { name: 'WSJ DollarIdx', symbol: 'XX:BUXX' }
  ],
  Bonds: [
    { name: '10 Year Yield', symbol: 'BX:TMUBMUSD10Y' }
  ],
  'Foreign Indexes': [
    { name: 'Stoxx Europe 600', symbol: 'XX:SXXP' },
    { name: 'Nikkei IDX', symbol: 'JP:NIK' },
    { name: 'HANG SENG INDEX', symbol: 'HK:HSI' },
    { name: 'Shanghai Comp', symbol: 'CN:SHCOMP' },
    { name: 'Shenzhen', symbol: 'CN:399106' }
  ]
};

export const RANGE = {
  '1D': { start: 'PT1M', end: 'PT1H', default: 'PT5M' },
  '2D': { start: 'PT1M', end: 'PT1H', default: 'PT5M' },
  '3D': { start: 'PT1M', end: 'PT1H', default: 'PT5M' },
  '4D': { start: 'PT1M', end: 'PT1H', default: 'PT10M' },
  '5D': { start: 'PT1M', end: 'P1D', default: 'PT10M' },
  '10D': { start: 'PT1M', end: 'P1D', default: 'PT15M' },
  '1M': { start: 'P1D', end: 'P7D', default: 'P1D' },
  '3M': { start: 'P1D', end: 'P1M', default: 'P1D' },
  '6M': { start: 'P1D', end: 'P3M', default: 'P1D' },
  'YTD': { start: 'P1D', end: 'P1M', default: 'P1D' },
  '1Y': { start: 'P1D', end: 'P3M', default: 'P1D' },
  '2Y': { start: 'P1D', end: 'P1Y', default: 'P7D' },
  '3Y': { start: 'P1D', end: 'P1Y', default: 'P7D' },
  '5Y': { start: 'P1D', end: 'P1Y', default: 'P1M' },
  '10Y': { start: 'P1D', end: 'P1Y', default: 'P3M' }
  // 'All': {}
};

export function getRangeOptions(isRolling) {
  const rangeValues = Object.keys(RANGE);
  if (!isRolling) rangeValues.push('Custom');
  return rangeValues;
}

const FREQUENCY = [
  { value: 'PT1M', text: '1 min' },
  { value: 'PT5M', text: '5 min' },
  { value: 'PT10M', text: '10 min' },
  { value: 'PT15M', text: '15 min' },
  { value: 'PT1H', text: 'Hourly' },
  { value: 'P1D', text: 'Daily' },
  { value: 'P7D', text: 'Weekly' },
  { value: 'P1M', text: 'Monthly' },
  { value: 'P3M', text: 'Quarterly' },
  { value: 'P1Y', text: 'Yearly' }
];

export function getFrequencyOptions(dateRange, startDate, endDate) {
  // populate frequency dropdown with proper options for specified date range
  if (startDate) {
    // for custom dates, determine which preset date range is closest in length
    const [unixStart, unixEnd] = [startDate, endDate].map(convertDate);
    const timeSpan = unixEnd - unixStart;
    dateRange = getRange(timeSpan);
  }
  const { start, end, default: defaultFrequency } = RANGE[dateRange];
  const [startIdx, endIdx] = [start, end].map(findFrequencyIndex);
  const frequencyOptions = FREQUENCY.slice(startIdx, endIdx + 1);
  return { frequencyOptions, defaultFrequency };
}

export function parseDateRange(dateRange) {
  return {
    timePeriodType: dateRange.slice(-1),
    timeValue: +dateRange.slice(0, -1)
  };
}

// getFrequencyOptions helper functions
function convertDate(date) {
  return moment(date).format('x');
}

function getRange(timeSpan) {
  const timePeriods = getTimePeriods();
  let range, milliseconds;
  for (let i = 0; i < timePeriods.length; i++) {
    const current = timePeriods[i];
    [range, milliseconds] = [current.range, current.milliseconds];
    if (timeSpan < milliseconds) {
      if (i === 0) return range;
      const prev = timePeriods[i - 1];
      return timeSpan - prev.milliseconds > milliseconds - timeSpan ?
        range : prev.range;
    }
  }
  return range;
}

function getTimePeriods() {
  return Object.keys(RANGE)
    .map(createTimeSpanObj)
    .filter(rangeObj => !isNaN(rangeObj.milliseconds));
}

const D = 1000 * 60 * 60 * 24;
const M = D * 30;
const Y = D * 365;

const TIMETYPES = { D, M, Y };

function createTimeSpanObj(range) {
  const { timePeriodType, timeValue } = parseDateRange(range);
  const milliseconds = TIMETYPES[timePeriodType] * timeValue;
  return { range, milliseconds };
}

function findFrequencyIndex(prop) {
  return FREQUENCY.findIndex(item => item.value === prop);
}



// WEBPACK FOOTER //
// ./src/ui/constants/marketdata.js